import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';
import { Gateway } from 'types/gateway';

import { updateQueriesData } from 'services/update_queries_data';
import { useAPI } from 'hooks/api/useAPI';

export function useDeleteGateway({
  onMutate,
  onError,
  onSettled,
  ...options
}: UseMutationOptions<void, APIError, string> = {}) {
  const queryClient = useQueryClient();
  const { client, applicationID } = useAPI();

  return useMutation({
    ...options,
    mutationFn(id) {
      return client.delete(`/apps/${applicationID}/gateways/${id}`);
    },
    async onMutate(id) {
      await queryClient.cancelQueries(['gateway']);
      await queryClient.cancelQueries(['gateways']);

      onMutate?.(id);

      return updateQueriesData<Gateway>({
        queryClient,
        listQueryKey: ['gateways'],
        singleQueryKey: ['gateway'],
        ids: [id],
        updateData: null,
      });
    },
    onError(error, id, context) {
      onError?.(error, id, context);

      context?.previousLists?.forEach(([queryKey, data]) =>
        queryClient.setQueryData(queryKey, data)
      );
      context?.previousSingles?.forEach(([queryKey, data]) =>
        queryClient.setQueryData(queryKey, data)
      );
    },
    onSettled(...args) {
      onSettled?.(...args);
      queryClient.invalidateQueries(['gateways']);
    },
  });
}
